// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"eb7a5877","375":"9cf1c48b","564":"a8280994","889":"0c8918df","922":"633061dd"}[chunkId] + ".chunk.js";
};